export default __webpack_public_path__ + "img/beer.jpg?7fd2";